import { forwardRef } from 'react';
import classNames from 'classnames';

const RefactoredListBody = props => {
  const { children, innerRef, style, extraClassNames, twoColumns, ...rest } =
    props;
  return (
    <ul
      className={classNames('r-list__body', extraClassNames, {
        'r-list__body--two-cols': twoColumns
      })}
      style={style}
    >
      {children}
    </ul>
  );
};
export default RefactoredListBody;
